import { clearProductTourEntryPoint } from '../analytics/product-tour-analytics';

const PRODUCT_TOUR_RETURN_KEY = 'route42:product-tour:return-to';
const DEFAULT_PRODUCT_TOUR_RETURN = '/machines';

function isSafeInternalPath(path: string | null): path is string {
  return Boolean(path && path.startsWith('/') && !path.startsWith('//') && !path.startsWith('/tour'));
}

export function rememberProductTourReturnPath(path: string): void {
  if (!isSafeInternalPath(path)) return;
  try {
    sessionStorage.setItem(PRODUCT_TOUR_RETURN_KEY, path);
  } catch {
    // Return navigation is best-effort UX state only.
  }
}

export function getProductTourReturnPath(): string {
  try {
    const path = sessionStorage.getItem(PRODUCT_TOUR_RETURN_KEY);
    return isSafeInternalPath(path) ? path : DEFAULT_PRODUCT_TOUR_RETURN;
  } catch {
    return DEFAULT_PRODUCT_TOUR_RETURN;
  }
}

export function clearProductTourReturnPath(): void {
  try {
    sessionStorage.removeItem(PRODUCT_TOUR_RETURN_KEY);
  } catch {
    // Return navigation is best-effort UX state only.
  }
  clearProductTourEntryPoint();
}

export function isFirstMachineOnboardingReturnPath(path: string): boolean {
  if (!isSafeInternalPath(path)) return false;
  const query = path.includes('?') ? path.slice(path.indexOf('?') + 1) : '';
  return new URLSearchParams(query).get('onboarding') === 'first-machine';
}
